import comp from "./containers/ResourceBankContainer";
export default comp;
